import React from "react";
import { useState, useEffect } from "react";
import Logo from '../assets/logo.svg'
import M from 'materialize-css';
import Token from "../components/token";
import FormNewPass from "../components/formNewPass";
import { useNavigate } from "react-router-dom";
import { ICONS } from '../assets/icons';
import { guardarAccionBitacora } from '../firestore';

function OlvidePass() {
    const [usuario, setUsuario] = useState("");
    const [correo, setCorreo] = useState("");
    const [step, setStep] = useState(0)
    const navigate = useNavigate();

    useEffect(() => {
        M.Modal.init(document.getElementById('preVerifica'), {
            dismissible: false,
            onOpenEnd: () => {

                // logEvent(analytics, "Login_verificar_correo", {
                //     screen_name: "Login",
                // });
            }
        });
    }, []);

    function submitLogin(e) {
        e.preventDefault()
        
        guardarAccionBitacora("IntentoRestablecimiento", "Inició intento de restablecimiento de contraseña", "INFO", usuario);

        setStep(step + 1)
    }

    function submitVerifica() {
        guardarAccionBitacora("EnvioOTP", "Se solicitó envío de OTP / código temporal", "INFO", usuario);
        setStep(step + 1)

        M.Modal.getInstance(document.getElementById('preVerifica')).close();
    }

    function showStep() {
        if (step === 0) {
            return (
                <form onSubmit={submitLogin}>
                    <div className="col s12 mt-4">
                        <span>Ingresa tu usuario</span>
                    </div>

                    <div className="input-field col s12 mt-2">
                        <input id="user" type="text"
                            value={usuario}
                            onChange={(e) => {
                                setUsuario(e.target.value)
                            }}
                        />
                        <label htmlFor="user">Usuario</label>
                    </div>
                    <div className="col s6 mt-1">
                        <button onClick={() => {
                            guardarAccionBitacora("AbandonoRestablecimiento", "Abandonó el flujo en el paso 0", "INFO", usuario);
                            navigate('/')
                        }}

                            className="btn waves-effect light btnActC white">Cancelar</button>
                    </div>
                    <div className="col s6 mt-1">
                        <button type="submit"
                            disabled={usuario.trim().length === 0}
                            className="btn btn-webSi-primary waves-effect light">Continuar</button>
                    </div>
                </form>
            )
        } else if (step === 1) {
            return (
                <React.Fragment>
                    <div className="col s12 mt-2">
                        <span className="ft-20 boldText">Valida tu correo eléctronico</span>
                    </div>
                    <div className="col s12 mt-2">
                        <span className="ft-16">Por tu seguridad, necesitamos validar tu información.</span>
                    </div>
                    <div className="col s12 mt-2">
                        <span className="ft-16">Confirma que es tu correo electrónico</span>
                        <p className="ft-16  boldText mt-0">a******@g****.com</p>
                    </div>

                    <div className="input-field col s12 mt-05">
                        <p className="ft-16 primaryText boldText">¿No es tu correo electrónico?</p>
                    </div>
                    <div className="col s6 mt-2">
                        <button type="button"
                            onClick={() => {
                                guardarAccionBitacora("AbandonoRestablecimiento", "Abandonó el flujo en el paso 1", "INFO", usuario);
                                navigate('/')
                            }}
                            className="btn waves-effect light btnActC white">Cancelar</button>
                    </div>
                    <div className="col s6 mt-2">
                        <button type="button"
                            onClick={() => {
                                setStep(step + 1)
                            }}
                            className="btn btn-webSi-primary waves-effect light">Continuar</button>
                    </div>
                </React.Fragment>
            )
        } else if (step === 2) {
            return (
                <form id="formVerifica">
                    <div className="col s12 mt-2">
                        <span className="ft-20 boldText">Valida tu correo eléctronico</span>
                    </div>

                    <div className="input-field col s12 mt-2">
                        <input id="user" type="text"
                            value={usuario}
                            onChange={(e) => {
                                setUsuario(e.target.value)
                            }}
                        />
                        <label htmlFor="user">Usuario</label>
                    </div>
                    <div className="input-field col s12 mt-2">
                        <input id="correo" type="text"
                            value={correo}
                            onChange={(e) => {
                                setCorreo(e.target.value)
                            }}
                        />
                        <label htmlFor="correo">Correo electrónico</label>
                    </div>
                    <div className="col s6 mt-1">
                        <button type="button" onClick={() => {
                            guardarAccionBitacora("AbandonoRestablecimiento", "Abandonó el flujo en el paso 2", "INFO", usuario);
                            navigate('/')
                        }}

                            className="btn waves-effect light btnActC white">Cancelar</button>
                    </div>
                    <div className="col s6 mt-1">
                        <button type="button" onClick={() => {
                            let instance = M.Modal.getInstance(document.getElementById('preVerifica'));
                            if (instance) {
                                instance.open();
                            }
                        }}
                            disabled={usuario.trim().length === 0}
                            className="btn btn-webSi-primary waves-effect light">Recibir código</button>
                    </div>
                </form>
            )
        }
        else if (step === 3) {
            return (
                <React.Fragment>
                     <div className="col s12 mt-2">
                        <span className="ft-20 boldText">Código de seguridad</span>
                    </div>

                    <div className="col s12 mt-2" style={{ lineHeight: "7px" }}>
                        <p className="ft-16 labelNavy">Ingresa el código de 6 dígitos que hemos</p>
                        <p className="ft-16 primaryText">enviado a a******@g****.com</p>
                    </div>
                    <div className="col s12 mt-2">
                        <Token callBack={() => {
                            setStep(step + 1)
                        }} />
                    </div>

                    <div className="col s12 mt-2" style={{paddingRight: '2.5rem !important', paddingLeft:'2.5rem !important'}}>
                        <button type="button" onClick={() => {
                            navigate('/')
                        }}

                            className="btn waves-effect light btnActC white">Cancelar</button>
                    </div>
                </React.Fragment>
            )
        }
    }

    const formReset = () => {
        return (
            <React.Fragment>
                <div className="col s12 m12 l2">
                    <img src={Logo} alt="logo" className="logoForgot" />
                </div>
                <div className="col s12 m12 l10 center-align boldText pt-1">
                    <span className="ft-20">Reestablece tu contraseña</span>
                </div>
                <div className="col s12 m12 l10 mt-2 offset-l2">
                    <div className="row">
                        <div className="col s12">
                            <span className="ft-16 labelNavy">Esta será tu nueva contraseña para futuras sesiones</span>
                        </div>
                    </div>
                </div>
                <div className="col s12 m12 l10 offset-l2">
                    <FormNewPass />
                </div>
            </React.Fragment>
        )
    }


    return (
        <React.Fragment>
            <div className="loginModule" style={{ height: "100%" }}>
                <div className="container">
                    <div className="row">
                        <div className="col s12 loginForm">
                            <div className="row">
                                <div className="col s12 m8 offset-m2 white wrapperLogin">
                                    <div className="valign-wrapper center-align">
                                        <div className="row w-100" >
                                            {
                                                step === 4 ?

                                                    formReset()
                                                    :
                                                    <React.Fragment>
                                                        <div className="col s12">
                                                            <img src={Logo} alt="logo" />
                                                        </div>

                                                        {showStep()}

                                                        {/* {
                                                            step < 2 ?
                                                                <div className="col s12 mt-2">
                                                                    <Link to="/"><span>Iniciar Sesión</span></Link>
                                                                </div>
                                                                : null
                                                        } */}
                                                    </React.Fragment>
                                            }


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="preVerifica" className="modal">
                <div className="modal-content">

                    <div className="row">
                        <div className="col s12 mt-2 center-align">
                            <span className="ft-20 boldText">Valida tu correo eléctronico</span>
                        </div>

                        <div className="col s12 mt-2 center-align">
                            <img src={ICONS.candado} alt="candado" style={{ width: "200px" }} />
                        </div>

                        <div className="col s12 mt-2 center-align">
                            <p>Por seguridad, enviamos un código de acceso temporal a tu correo electrónico registrado.</p>
                        </div>


                        <div className="col s12 mt-1 center-align">
                            <button onClick={() => {
                                submitVerifica();
                            }}
                                className="btn btn-webSi-primary waves-effect light">Entendido</button>
                        </div>
                    </div>


                </div>
            </div>

        </React.Fragment>
    )
}

export default OlvidePass;